{
  "_provenance": {
    "ns": "legal",
    "source": "the legal pages and the DocumentRenderer notice — document bodies stay English (R3-B9) (#2109 R3 lane L7)"
  },
  "accountClose": {
    "action": "Schedule account closure",
    "actionFailed": "That didn’t go through. Please try again.",
    "alreadyScheduledNotice": "Your account was already scheduled to close. The date has not changed.",
    "body": "Your account will be scheduled for closure with a 30-day grace period.",
    "cancelAction": "Cancel the closure",
    "cancelledNotice": "Closure cancelled. Your account stays open.",
    "confirmAction": "Yes, schedule closure",
    "confirmBody": "Your account will close in {{days}} days. You can keep using it until then, and cancel any time from this page or from Settings.",
    "confirmDismiss": "Not now",
    "confirmTitle": "Schedule your account to close?",
    "eyebrow": "Account",
    "loadFailed": "We couldn’t check whether a closure is scheduled. Refresh the page to try again.",
    "scheduledBody": "Your account will close on {{date}}. You can keep using it until then, and cancel the closure here any time before that.",
    "scheduledTitle": "Account closure scheduled",
    "title": "Close your account"
  },
  "document": {
    "draft": "DRAFT — pending final review. This text is provided for transparency and may be updated.",
    "englishNotice": "This document is in English. The English text is the one that applies.",
    "meta": "Version {{version}} · Effective {{date}}",
    "modalTitle": "Legal document",
    "unavailable": "This document is temporarily unavailable."
  },
  "index": {
    "title": "Legal & Policies",
    "version": "v{{version}}"
  },
  "settingsPage": {
    "empty": "No recorded agreements yet.",
    "event": {
      "accepted": "Accepted",
      "declined": "Declined",
      "reaccepted": "Reaccepted",
      "revoked": "Revoked"
    },
    "eventLine": "{{event}} · v{{version}}",
    "eyebrow": "Settings · Legal",
    "lede": "The documents you have agreed to, and when.",
    "title": "Your <em>agreements</em>."
  }
}
